import React, { useState } from 'react'
import { useDeleteRequest } from '../../hooks/request'
import { useModal } from '../../hooks/modal'
import { ANIMAL_RECORD_DETAIL } from '../../urls'
import AnimalRecordUpdate from './AnimalRecordUpdate'
import Button from '../common/Button'
import ImageGalleryModal from '../common/ImageGalleryModal'
import { getDate } from '../../utils/date'

export default function AnimalRecordItem({ item, index, onRefresh }) {
    const recordRemove = useDeleteRequest({ url: ANIMAL_RECORD_DETAIL.replace('{id}', item.id) })
    const [showGallery, setShowGallery] = useState(false)
    const [selectedImageIndex, setSelectedImageIndex] = useState(0)

    const [showUpdateModal, setShowUpdateModal] = useModal(
        <AnimalRecordUpdate
            item={item}
            onSuccess={() => {
                onRefresh()
                setShowUpdateModal()
            }}
            onCancel={() => setShowUpdateModal()}
        />,
    )

    async function onDelete() {
        if (global.confirm('Сиз чинакамдан ўчиришни истайсизми?')) {
            const { success } = await recordRemove.request()
            if (success) {
                onRefresh()
            }
        }
    }

    const openGallery = (imgIndex) => {
        setSelectedImageIndex(imgIndex)
        setShowGallery(true)
    }

    // function getHealthStatusClass() {
    //     const status = item.health_status?.toLowerCase() || ''
    //     if (status.includes('яхши') || status.includes('good')) {
    //         return 'is-success'
    //     }
    //     if (status.includes('касал') || status.includes('sick')) {
    //         return 'is-danger'
    //     }
    //     return 'is-warning'
    // }

    return (
        <tr className="is-size-6">
            <td>{index + 1}</td>
            <td>{getDate(item.record_date)}</td>
            <td>{item.weight ? `${item.weight} кг` : '-'}</td>
            {/* <td>
                <span className={`tag ${getHealthStatusClass()}`}>
                    {item.health_status || 'Кўрсатилмаган'}
                </span>
            </td> */}
            <td style={{ maxWidth: '150px' }}>
                {item.images && item.images.length > 0 ? (
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', alignItems: 'center' }}>
                        {item.images.slice(0, 3).map((img, idx) => (
                            <img
                                key={img.id}
                                src={img.image}
                                alt={img.caption || 'Расм'}
                                onClick={() => openGallery(idx)}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    minWidth: '40px',
                                    minHeight: '40px',
                                    maxWidth: '40px',
                                    maxHeight: '40px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    border: '1px solid #e8e8e8',
                                    cursor: 'pointer',
                                    transition: 'transform 0.2s, box-shadow 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'scale(1.1)'
                                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)'
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'scale(1)'
                                    e.target.style.boxShadow = 'none'
                                }}
                            />
                        ))}
                        {item.images.length > 3 && (
                            <span
                                className="tag is-info is-small"
                                onClick={() => openGallery(0)}
                                style={{ cursor: 'pointer' }}
                                title="Барча расмларни кўриш"
                            >
                                +{item.images.length - 3}
                            </span>
                        )}
                    </div>
                ) : (
                    <span className="has-text-grey-light">-</span>
                )}
            </td>
            <td>{item.notes || '-'}</td>
            <td>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button
                        onClick={showUpdateModal}
                        className="button is-success is-outlined is-small"
                        icon="pencil-outline"
                    />
                    <Button
                        onClick={onDelete}
                        className="button is-danger is-outlined is-small"
                        icon="trash"
                        loading={recordRemove.loading}
                    />
                </div>
            </td>

            {/* Image Gallery Modal */}
            {showGallery && (
                <ImageGalleryModal
                    images={item.images}
                    initialIndex={selectedImageIndex}
                    onClose={() => setShowGallery(false)}
                />
            )}
        </tr>
    )
}
